import { Swiper, Navigation, EffectFade } from 'swiper';

function revealMediaWithTextBlocks() {
  document.querySelectorAll('.c-media-with-text').forEach((rootEl) => {
    rootEl.classList.add('c-media-with-text--ready');
    rootEl.style.removeProperty('visibility');
  });
}

function initMediaWithText(rootEl) {
  if (!rootEl) {
    return;
  }

  const swiperEl = rootEl.querySelector('.c-media-with-text__swiper');
  if (!swiperEl) {
    return;
  }

  const prevEl = rootEl.querySelector('.swiper-nav__button--prev');
  const nextEl = rootEl.querySelector('.swiper-nav__button--next');
  if (!prevEl || !nextEl) {
    return;
  }

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    return;
  }

  // eslint-disable-next-line no-unused-vars
  const swiper = new Swiper(swiperEl, {
    modules: [Navigation, EffectFade],
    loop: false,
    rewind: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 700,
    slidesPerView: 1,
    navigation: {
      prevEl,
      nextEl,
    },
    on: {
      slideChange(swiperInstance) {
        const prevSlide = swiperInstance.slides[swiperInstance.previousIndex];
        prevSlide.querySelector('video')?.mediaControl?.pause();

        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        activeSlide.querySelector('video')?.mediaControl?.playIfAble();
      },
    },
  });
}

function initAllMediaWithText() {
  document.querySelectorAll('.c-media-with-text').forEach(initMediaWithText);
}

function scheduleMediaWithTextStart() {
  const start = () => {
    revealMediaWithTextBlocks();
    initAllMediaWithText();
  };

  if (document.readyState === 'complete') {
    start();
    return;
  }

  window.addEventListener('load', start, { once: true });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-media-with-text', () => {
      revealMediaWithTextBlocks();
      initAllMediaWithText();
    });
  }
});

scheduleMediaWithTextStart();
